import defaultAttributes from '../defaultAttributes';

const Music3 = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '12', cy: '18', r: '4' }],
    ['path', { d: 'M16 18V2' }],
  ],
];

export default Music3;
